import { render } from "./ViewTaskRevisionsModal.vue?vue&type=template&id=3820c98d&scoped=true"
import script from "./ViewTaskRevisionsModal.vue?vue&type=script&lang=js"
export * from "./ViewTaskRevisionsModal.vue?vue&type=script&lang=js"

import "./ViewTaskRevisionsModal.vue?vue&type=style&index=0&id=3820c98d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3820c98d"]])

export default __exports__